import '.bl{flex-shrink:0;}.ssr-plugin'
import '.bd{padding:1rem;}.ssr-plugin'
import '.x{width:100%;}.ssr-plugin'
import '.bi{height:100%;}.ssr-plugin'
import '.bn{border:none;}.ssr-plugin'
import '.gr{background-color:transparent;}.ssr-plugin'
import '.gs{border-radius:0px;}.ssr-plugin'
import '.d{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.aa{align-items:stretch;}.ssr-plugin'
import '.cs{position:sticky;}.ssr-plugin'
import '.gt{top:4rem;}.ssr-plugin'
import '.gu{z-index:7;}.ssr-plugin'
import '.ad{background-color:var(--palette-white);}.ssr-plugin'
import '.gv{padding-bottom:1rem;}.ssr-plugin'
import '.a4{margin-bottom:1rem;}.ssr-plugin'
import '.gw{border-bottom:var(--border-subtle);}.ssr-plugin'
import '.i{position:fixed;}.ssr-plugin'
import '.ct{top:0px;}.ssr-plugin'
import '.bg{left:0px;}.ssr-plugin'
import '.bh{right:0px;}.ssr-plugin'
import '.g0{bottom:0px;}.ssr-plugin'
import '.gx{z-index:9999;}.ssr-plugin'
import '.gy{transition:transform 0.3s ease-in-out;}.ssr-plugin'
import '.dh{justify-content:flex-end;}.ssr-plugin'
import '.bk{flex:1;}.ssr-plugin'
import '.ay{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import {
  isValidElement,
  PropsWithChildren,
  ReactNode,
  useState,
  useEffect,
} from 'react'
import { useLocation } from 'wouter'
import { TextLink } from '@app/components/core/link/TextLink'
import { CloseButton } from '@app/components/core/button/CloseButton'

interface LeftSidebarMobileProps {
  sidebar: ReactNode
  content: ReactNode[]
}

const Sidebar = ({
  children,
  style,
}: PropsWithChildren & { style?: Style }) => {
  return (
    <styled.aside className="bl bd x bi bn gr gs"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.aside>
  )
}

export const LeftSidebarMobile = ({
  sidebar,
  content,
}: LeftSidebarMobileProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const [location] = useLocation()

  // Close sidebar when route changes
  useEffect(() => {
    setIsOpen(false)
  }, [location])

  const collapsedButtonLabel =
    (isValidElement(sidebar) && sidebar.props.collapsedButtonLabel) || 'Menu'

  const sidebarContent = isValidElement(sidebar) ? sidebar.props.children : null
  const sidebarStyle = isValidElement(sidebar) ? sidebar.props.style : undefined

  return (
    <div className="d e aa"
    >
      <div className="cs gt gu ad gv a4 gw d"
      >
        <TextLink onClick={() => setIsOpen(true)}>{collapsedButtonLabel}</TextLink>
      </div>

      <div className="i ct bg bh g0 gx ad gy d e"
        style={{
          transform: isOpen ? 'translateX(0)' : 'translateX(-100%)',}}
      >
        <div className="bd d dh gw"
        >
          <CloseButton onClick={() => setIsOpen(false)} />
        </div>
        <div className="bk ay">
          <Sidebar style={sidebarStyle}>{sidebarContent}</Sidebar>
        </div>
      </div>

      {content}
    </div>
  )
}
